<template>
    <div v-bind:logs="logs">
        <h1>Logs</h1>             
        
        <table class="table">
            <tr>
                <th>Date</th><th>Type</th><th>Message</th>
            </tr>            
            <tr v-for="log in logs" v-bind:key="log.id">
                <td>{{ log.date | formatDate }}</td>
                <td>{{ log.type }}</td>
                <td>{{ log.message }}</td>
            </tr>
        </table>
    </div>
</template>

<script>
    
    import ApiClient from '@/tools/apiClient.js';

    let api = new ApiClient();

    export default {
        name: 'logs',            
        data: function () {
            return {
                logs: [],                        
            }
        },

        created: async function () {
            this.logs = await api.getAllLogsAsync();
        },
    }
</script>
